import { render, staticRenderFns } from "./activityTypesTable.vue?vue&type=template&id=ef426426"
import script from "./activityTypesTable.vue?vue&type=script&lang=js"
export * from "./activityTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports